<template>
  <el-dialog
    title="提示"
    :visible.sync="csDialogConfirmVisible"
    :before-close="cancelClick"
    width="40%">
    <div  v-if="formData.type==10">
      <div>
      此课程信息原为：【课程分类 - 非经销商】、【课程类型 - 远程培训】，请确定是否修改课程分类或者课程类型？
      </div>
      
      <br/>
      <div style="text-align: right; margin-top: 10px;">
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelClick">取 消</el-button>
          <el-button type="primary" @click="submitClick">确定</el-button>
        </span>
      </div>
      
    </div>
    
     <div v-show="formData.type==20">
      <div>
        此课程信息原为：【课程分类 - 经销商】、【课程类型 - 远程培训】，请确定是否修改课程分类或者课程类型？
      </div>
      
      <br/>
      <div style="text-align: right; margin-top: 10px;">
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelClick">取 消</el-button>
          <el-button type="primary" @click="submitClick">确定</el-button>
        </span>
      </div>
      
    </div>
  </el-dialog>  
</template>

<script>
import http from "@/utils/http";
import courseVerification from '@/components/rm/courseVerification/index'
export default {
  components: {courseVerification},
  props: {
    csDialogConfirmVisible: Boolean,
    csDialogVisible:Boolean,
    formData: Object,

    courseVerificationForm:Array,
    total: Number,
    courseResType: Number,
    courseObj: Object
  },
  data() {
    return {
      tableData: [
        {
          offeringNo: 'test',
          offeringStatus: 'test',
          startdate: 'test',
          enddate: 'test',
          remark: 'test'
        }
      ],
      currentPage: 1,
      csDialogVisible:true,
      cancleDialog: true
    }
  },
  methods: {
    cancelClick() {
      this.currentPage = 1
      // this.$refs.pagination.internalCurrentPage = this.currentPage
      this.$emit('coursePageConfirmOk', 'cancel', this.formData.type)
    },
    submitClick() {
      this.$emit('coursePageConfirmOk', 'submit', this.formData.type)
    }
  }
}
</script>

<style scoped lang="scss">
.mainClass {
  width: 100%;
  min-height: 100px;
}
</style>
